<template>
  <div class="flex flex-col">
    <el-form :model="queryForm" :rules="queryRules" ref="formRef" class="mb-4">
      <div class="flex flex-row gap-4 justify-end">
        <el-form-item label="" prop="group_name">
          <el-input
            v-model="queryForm.group_name"
            placeholder="Enter group name"
            class="w-full!"
          />
        </el-form-item>
        <el-form-item label="" prop="owner_phone">
          <el-input
            v-model="queryForm.owner_phone"
            placeholder="Enter owner phone"
            class="w-full!"
          />
        </el-form-item>
        <span class="flex flex-row items-start">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="handleSearch"
          >
            Search
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            @click="queryFormRef?.resetFields()"
          >
            clear
          </el-button>
        </span>
      </div>
    </el-form>

    <div v-if="groups.length">
      <div
        v-for="group in groups"
        :key="group.id"
        class="flex items-start border rounded p-2 mb-2 cursor-pointer"
        @click="handleChecked(group.id)"
        :style="{ background: selectedGroupId === group.id ? 'black' : '' }"
      >
        <span class="mt-2 ml-1">
          <i
            v-if="selectedGroupId === group.id"
            class="el-icon-circle-check w-4 h-4 text-green-500"
          />
          <i v-else class="inline-block rounded-full w-4 h-4 border" />
        </span>
        <el-descriptions :column="2" border class="flex-1 ml-4">
          <el-descriptions-item label="Group ID">{{
            group.id
          }}</el-descriptions-item>
          <el-descriptions-item label="Subject">{{
            group.subject
          }}</el-descriptions-item>
          <el-descriptions-item label="Description">{{
            group.desc
          }}</el-descriptions-item>
          <el-descriptions-item label="Size">{{
            group.size
          }}</el-descriptions-item>
          <el-descriptions-item label="Owner Phone">{{
            group.owner_phone
          }}</el-descriptions-item>
          <el-descriptions-item label="Created At">{{
            group.created_at
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <el-empty v-else description="No groups found" />
    <div class="flex flex-row justify-end">
      <el-button @click="emit('cancel')">Cancel</el-button>
      <el-button
        type="primary"
        :disabled="selectedGroupId == '' || groups.length === 0"
        @click="handleConfirm"
      >
        Confirm
      </el-button>
    </div>
  </div>
</template>

<script>
import { getWhatsAppGroups } from "@/api";

export default {
  name: "WhatsAppGroupIDPicker",
  components: {},
  props: {
    groupId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      queryForm: {
        group_name: "",
        owner_phone: "",
      },
      queryFormRef: null,
      queryRules: {
        group_name: [
          {
            required: true,
            message: "Please enter group name",
            trigger: "blur",
          },
        ],
        owner_phone: [
          {
            required: true,
            message: "Please enter owner phone",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      groups: [],
      selectedGroupId: this.groupId || null,
    };
  },
  watch: {
    groups: {
      handler() {
        if (this.groupId && this.groups.some((g) => g.id === this.groupId)) {
          this.selectedGroupId = this.groupId;
        } else if (this.groups.length) {
          this.selectedGroupId = this.groups[0].id;
        } else {
          this.selectedGroupId = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    async handleSearch() {
      await this.$refs.formRef.validate();

      this.loading = true;
      try {
        const res = await getWhatsAppGroups(
          this.queryForm.group_name,
          this.queryForm.owner_phone
        );
        this.groups = res.groups || [];
        if (!this.groups.length) {
          this.$message.info("No groups found.");
        }
      } catch {
        this.$message.error("Failed to fetch groups.");
      } finally {
        this.loading = false;
      }
    },
    handleConfirm() {
      if (this.selectedGroupId) {
        this.$emit("confirm", this.selectedGroupId);
      }
    },
    handleChecked(groupId) {
      this.selectedGroupId = groupId;
    },
    emit(event) {
      this.$emit(event);
    },
  },
};
</script>
